import { ReactNode } from 'react'
import { Helmet } from 'react-helmet-async'

import { getQueryParamsFromHash, parsePermittedQueryParams } from '@domain-group/javascript-utils'

import { Box, Button, Columns } from '@domain-group/suit-theme'

import useUser, { generateUrls } from '@hooks/useUser'

import EnabledPermission from '@components/EnabledPermission'
import PageHeader from '@components/PageHeader'

import useCurrentUser from '@hooks/useCurrentUser'
import generateTabBarItems from '../../utils/generateTabBarItems'

interface PageLayoutProps {
  activeTabBarItemKey?: string,
  children: ReactNode,
  selectedAgencyId: number,
  userPayload: ReturnType<typeof useUser>,
}

const PageLayout = (props: PageLayoutProps) => {
  const {
    activeTabBarItemKey,
    userPayload: {
      user,
    },
    children,
    selectedAgencyId,
  } = props

  const { redirect } = parsePermittedQueryParams(getQueryParamsFromHash(), ['redirect'])

  const urls = generateUrls(user, { prefixRoute: `agencies/${selectedAgencyId}/manage` })
  const { usersIndexUrl } = urls

  const { isAgent } = useCurrentUser()

  return (
    <>
      <Helmet>
        <title>Edit User | Realhub</title>
      </Helmet>

      <PageHeader
        actionContent={(
          <EnabledPermission permissionKey="admin.users.manage">
            <Button
              // @ts-expect-error TS2322
              as="a"
              buttonStyle="secondaryUtility"
              href={redirect || usersIndexUrl}
              size="medium"
              width="auto"
            >
              Back
            </Button>
          </EnabledPermission>
        )}
        activeTabBarItemKey={activeTabBarItemKey}
        nestedNavigation={!isAgent}
        tabBarItems={generateTabBarItems(user, urls)}
        title="Edit User"
      />

      <Box paddingX="large" paddingTop={[112, 105]}>
        <Columns boxProps={{ marginTop: 'large' }} flexDirection={['column', 'column', 'row']}>
          {children}
        </Columns>
      </Box>
    </>
  )
}

export default PageLayout
